import { useLingui } from '@lingui/react';
import { useLocation } from 'react-router-dom';
import PdfPreview from '../../Molecules/Document/PdfPreviewNew';
import { IconX } from '@tabler/icons';
import { ActionIcon, Group } from '@mantine/core';

const EmailDocumentAttachment = ({ eventId, attachment, deleteAtIndex, index }) => {
  const { i18n } = useLingui();
  const { pathname } = useLocation();

  if (!pathname.includes('emails')) {
    attachment.fileName = i18n._(`document.${attachment.documentType.toLowerCase()}`);
  }

  return (
    <Group
      p="xs"
      sx={(theme) => ({
        borderRadius: theme.radius.sm,
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[0],
      })}
    >
      {!pathname.includes('emails') && <PdfPreview file={attachment} eventId={eventId} />}

      {/* 
      <div style={styles.fileName}>{attachment.fileName}</div> */}

      {!pathname.includes('emails') && (
        <div>{attachment.templateName && <div>Vorlage: {attachment.templateName}</div>}</div>
      )}

      {deleteAtIndex && (
        <ActionIcon size="xs">
          <IconX onClick={() => deleteAtIndex(index)} />
        </ActionIcon>
      )}
    </Group>
  );
};

export default EmailDocumentAttachment;
